/** Subject pronoun from wizard gender selection. */
export function subjectPronoun(gender) {
  if (gender === "male") return "he";
  if (gender === "female") return "she";
  return "they";
}

/** Reflexive pronoun from wizard gender selection. */
export function reflexivePronoun(gender) {
  if (gender === "male") return "himself";
  if (gender === "female") return "herself";
  return "themselves";
}
